import { css } from 'lit';
export default css ` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #TOGGLE
\*------------------------------------ */
/**
 * Toggle variables which allow an application to change the width and height of the toggle if needed
 */
:host {
  --cat-toggle-width: 50px;
  --cat-toggle-height: 24px;
  display: flex;
}

/**
 * Toggle
 * 1) On/Off toggle switch
 */
.cat-c-toggle {
  position: relative;
  display: inline-flex;
  flex-direction: column;
}

/**
 * Disabled cursor for Toggle Label
 */
.cat-c-toggle-label {
  /**
   * visually hides the label 
   */
}
.cat-is-disabled .cat-c-toggle-label {
  cursor: default;
}
.cat-c-toggle-hidden--label .cat-c-toggle-label {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
 * Toggle label
 * 1) The label element that is styled in a pill shape
 */
.cat-c-toggle__handle {
  position: absolute;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: var(--cat-toggle-width);
  height: var(--cat-toggle-height);
  border-radius: var(--cat-border-radius-xl);
  background-color: var(--cat-theme-color-background-strong);
  overflow: hidden;
  white-space: nowrap;
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  /**
   * If disabled, changes the background color of the pill shape
   */
}
.cat-is-disabled .cat-c-toggle__handle {
  cursor: not-allowed;
  pointer-events: none;
  background-color: var(--cat-theme-color-background-subtle);
}
.cat-is-readonly .cat-c-toggle__handle {
  background-color: var(--cat-theme-color-form-background);
  border: 1px solid var(--cat-theme-color-border-readonly);
}

/**
   * If Readonly,then pointer events will be none
   */
.cat-is-readonly {
  pointer-events: none;
}

/**
 * Toggle label after
 * 1) The inner pill that slides based on the checked state
 */
.cat-c-toggle__handle:after {
  content: "";
  position: absolute;
  width: calc(50% - calc(var(--size-base-unit) * 0.625));
  height: calc(100% - calc(var(--size-base-unit) * 0.5));
  border-radius: var(--cat-toggle-height);
  background-color: var(--cat-theme-color-background-default);
  inset-block-start: calc(var(--size-base-unit) * 0.25);
  inset-inline-start: calc(var(--size-base-unit) * 0.25);
  transition: all var(--cat-anim-move-quick) var(--cat-anim-ease);
  border: var(--cat-theme-border-width) solid var(--cat-theme-color-border-strong);
}
.cat-is-disabled .cat-c-toggle__handle:after {
  border: 0;
}
.cat-is-readonly .cat-c-toggle__handle:after {
  background-color: var(--cat-theme-color-content-default);
  border: 1px solid var(--cat-theme-color-border-readonly);
}

/**
 * Toggle on/off
 * 1) The wrappers for the on/off slots
 */
.cat-c-toggle__on,
.cat-c-toggle__off {
  padding: var(--cat-space-3x-small) var(--cat-space-x-small);
  min-width: 50%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/**
 * Toggle on/off slots
 * 1) The slots for the on/off elements
 */
.cat-c-toggle__on slot,
.cat-c-toggle__off slot {
  --cat-icon-width: 13px;
  --cat-icon-height: 13px;
  display: block;
  color: var(--cat-theme-color-content-knockout);
  /**
   * If disabled, changes the color of the slotted content
   */
}
.cat-c-toggle__on slot:not(.cat-c-toggle__off slot),
.cat-c-toggle__off slot:not(.cat-c-toggle__off slot) {
  color: var(--cat-theme-color-content-default);
}
.cat-is-disabled .cat-c-toggle__on slot, .cat-is-checked.cat-is-disabled .cat-c-toggle__on slot,
.cat-is-disabled .cat-c-toggle__off slot,
.cat-is-checked.cat-is-disabled .cat-c-toggle__off slot {
  color: var(--cat-theme-color-content-disabled);
}
.cat-is-readonly .cat-c-toggle__on slot, .cat-is-checked.cat-is-readonly .cat-c-toggle__on slot,
.cat-is-readonly .cat-c-toggle__off slot,
.cat-is-checked.cat-is-readonly .cat-c-toggle__off slot {
  color: var(--cat-theme-color-content-default);
}

/**
 * Toggle checkbox
 * 1) The checkbox element that is visually hidden, but styled for focus-visible
 */
.cat-c-toggle__checkbox {
  display: block;
  min-width: var(--cat-toggle-width);
  height: var(--cat-toggle-height);
  border-radius: var(--cat-border-radius-xl);
  border: 0;
  margin: 0;
  padding: 0;
  appearance: none;
  position: relative;
  inset-block-start: 0;
  inset-inline-start: 0;
  /**
   * Disabled Cursor for toggle checkbox
   */
  /**
   * The focus visible state when a user tabs to the toggle
   */
}
.cat-c-toggle__checkbox:disabled {
  cursor: not-allowed;
}
.cat-c-toggle__checkbox:is(:focus, :focus-visible) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
 * Toggle checkbox is checked label
 * 1) If the checkbox is checked, then change the background color of the label
 */
.cat-c-toggle__checkbox:checked + .cat-c-toggle__handle {
  background-color: var(--cat-theme-color-background-brand);
  /**
   * If disabled, changes the pill shape background color if checked
   */
}
.cat-is-disabled .cat-c-toggle__checkbox:checked + .cat-c-toggle__handle {
  background-color: var(--cat-theme-color-background-brand-disabled);
}
.cat-is-readonly .cat-c-toggle__checkbox:checked + .cat-c-toggle__handle {
  background-color: initial;
}

/**
 * Toggle checkbox is checked label after
 * 1) If the checkbox is checked, then shift over the inner pill
 */
.cat-c-toggle__checkbox:checked + .cat-c-toggle__handle:after {
  inset-inline-start: calc(50% + calc(var(--size-base-unit) * 0.25));
}

/**
 * Toggle wrapper
 * 1) The wrapper around the toggle and asterisk to flex align the content
 */
.cat-c-toggle-wrapper {
  display: flex;
}

/**
 * Toggle disabled
 * 1) Prevent clicks if the toggle is disabled
 */
.cat-is-disabled .cat-c-toggle-label,
.cat-is-disabled .cat-c-toggle__value {
  color: var(--cat-theme-color-content-disabled);
}

/**
 * Toggle with label 
 * Displays over the toggle
 */
.cat-c-toggle-label {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  margin-block-end: var(--cat-space-x-small);
  cursor: pointer;
}

/**
 * Toggle with value
 * Displays right of the toggle
 */
.cat-c-toggle__value {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  padding-inline-start: var(--cat-space-x-small);
  word-break: break-word;
  hyphens: auto;
}

/**
 * toggle loader
 * Displays a loader if isLoading is set to true
 */
.cat-c-toggle__loader {
  display: flex;
  flex-direction: column;
  gap: var(--cat-space-x-small);
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 1);
}

.cat-c-toggle__loader-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--cat-space-3x-small);
}

.cat-c-toggle__loader-body {
  display: flex;
  gap: var(--cat-space-x-small);
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 1.5);
}

/**
 * Show label based on checked state
 */
:is(.cat-is-checked .cat-c__label--checked, :not(.cat-is-checked) .cat-c__label--unchecked) {
  display: inline;
}

.cat-is-checked .cat-c__label--unchecked,
.cat-c__label--checked {
  display: none;
}

.cat-c-toggle:not(.cat-c-toggle--has-field-note) [part=field-note-wrap], .cat-c-toggle:not(.cat-c-toggle--has-on) .cat-c-toggle__on, .cat-c-toggle:not(.cat-c-toggle--has-off) .cat-c-toggle__off, .cat-c-toggle:not(.cat-c-toggle--has-checked-label) .cat-c__label--checked, .cat-c-toggle:not(.cat-c-toggle--has-unchecked-label) .cat-c__label--unchecked {
  display: none;
}
`;
